module.exports = __webpack_public_path__ + "img/ef30e37.jpg";